import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  Box,
  Alert,
  AlertIcon,
  VStack,
  HStack,
  UnorderedList,
  ListItem,
  Icon,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

const DeleteUserModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  user, 
  isDeleting 
}) => {
  if (!user) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" closeOnOverlayClick={!isDeleting}>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent bg="#ffffff" borderColor="#e2e8f0" border="1px">
        <ModalHeader color="#1f2937" borderBottom="1px" borderColor="#e2e8f0">
          <HStack spacing={3}>
            <Icon as={WarningIcon} color="red.400" boxSize={5} />
            <Text>Delete User</Text>
          </HStack>
        </ModalHeader>
        
        {!isDeleting && <ModalCloseButton color="#1f2937" />}
        
        <ModalBody py={6}>
          <VStack spacing={4} align="stretch">
            <Text color="#1f2937" fontSize="md">
              Are you sure you want to delete{' '}
              <Text as="span" fontWeight="bold" color="red.300">
                {user.username}
              </Text>
              ?
            </Text>
            
            <Alert status="warning" bg="#2D1B0F" border="1px" borderColor="#D69E2E">
              <AlertIcon color="#D69E2E" />
              <Box>
                <Text fontWeight="bold" color="#D69E2E" mb={2}>
                  This action cannot be undone!
                </Text>
                <Text color="#D69E2E" fontSize="sm">
                  The following will be permanently deleted:
                </Text>
                <UnorderedList color="#D69E2E" fontSize="sm" mt={1} ml={4}>
                  <ListItem>The user account</ListItem>
                  <ListItem>All their conversations</ListItem>
                  <ListItem>All their messages</ListItem>
                  <ListItem>All associated data</ListItem>
                </UnorderedList>
              </Box>
            </Alert>

            <Box bg="#f8fafc" p={3} borderRadius="md" border="1px" borderColor="#e2e8f0">
              <Text color="gray.400" fontSize="sm" mb={1}>User Details:</Text>
              <Text color="#1f2937" fontSize="sm">
                <Text as="span" fontWeight="bold">Email:</Text> {user.email}
              </Text>
              <Text color="#1f2937" fontSize="sm">
                <Text as="span" fontWeight="bold">Available Models:</Text> {user.available_models?.length || 0}
              </Text>
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter borderTop="1px" borderColor="#e2e8f0">
          <HStack spacing={3}>
            <Button 
              variant="outline" 
              onClick={onClose}
              isDisabled={isDeleting}
              color="#1f2937"
              borderColor="#e2e8f0"
              _hover={{ bg: "#e2e8f0" }}
            >
              Cancel
            </Button>
            <Button 
              colorScheme="red" 
              onClick={onConfirm}
              isLoading={isDeleting}
              loadingText="Deleting..."
              _hover={{ bg: "red.600" }}
            >
              Delete User
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteUserModal;
